<template>
    <v-dialog v-model="show" max-width="700" persistent no-click-animation>
        <div class="ConfirmDeleteCustomer">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('confirm') }} {{ $t('delete') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <!--Content dialog-->
            <div class="dialog-content fci-scrollbar">
                <div style="font-size: 13px; font-style: italic; color: red">
                    <strong>*{{ $f.tc('notice') }}</strong>:
                    {{ $t('deleteCustomerNotice', { nameTab: $f.tc('output') }) }}
                </div>
                <table class="mt-8">
                    <thead>
                    <tr>
                        <th>{{ $f.tc('name') }}</th>
                        <th style="min-width: 150px">{{ $f.tc('phone') }}</th>
                        <th class="text-center" style="width: 90px">{{ $f.tc('action') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>{{ item.phone_numbers.map(i => i.phone_number).join(', ') }}</td>
                        <td class="text-center">
                            <v-btn icon class="mx-0" @click.stop="remove(item)">
                                <img src="/img/delete-blue.svg" alt="icon-delete"
                                     style="transform: scale(1.2); padding-left: 1px">
                            </v-btn>
                        </td>
                    </tr>
                    <tr v-if="items.length === 0">
                        <td colspan="3" class="text-center">{{ $f.tc('noDataAvailable') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <!--Footer dialog-->
            <div class="dialog-footer">
                <div v-if="items.length > 0" class="btn-danger mr-8" @click="deleteCustomers">{{ $f.tc('delete') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import CampaignService from "@/services/campaign.service";
import {mapState} from "vuex";

export default {
    name: "ConfirmDeleteCustomer",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            items: []
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        }),
    },
    methods: {
        open(customers) {
            this.show = true
            this.items = customers
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        close() {
            this.show = false
            this.promise.resolve()
            this.$emit('close')
        },
        remove(customer) {
            this.items = this.items.filter(item => item.id !== customer.id)
        },
        deleteCustomers() {
            this.$appService.showLoading()
            CampaignService.batchDeleteCustomer(
                this.campaign.id,
                this.items.map(item => item.id)
            ).then(
                () => {
                    this.$appService.toastSuccess('Deleted ' + this.items.length + ' customers')
                    this.promise.resolve(this.items.length)
                    this.close()
                },
            ).finally(this.$appService.hideLoading)
        },
    }
}
</script>

<style scoped lang="scss">
.ConfirmDeleteCustomer {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;
    width: 100%;

    .btn-custom {
        margin-right: 8px;
    }

    .dialog-content {
        max-height: calc(85vh - 100px);
        overflow-y: auto;
    }
}

table {
    border: 1px solid #96add0;
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;

    tr {
        height: 48px;
    }

    thead tr:not(.v-datatable__progress) {
        height: 48px !important;
    }

    thead th {
        text-transform: capitalize !important;
        color: #12274F !important;
        background: #E4EDFA;
        text-align: left;
    }

    th:nth-child(1) {
        padding-left: 12px;
    }

    th:nth-child(2) {
        padding-left: 6px;
    }

    tr {
        border-bottom: 1px solid #96add0;
    }

    tr {
        td {
            padding: 0 6px;

            &:first-child {
                padding-left: 12px;
            }
        }
    }
}
</style>
